import React from "react"
import {Container, ImageContainer, ImageTitle, ImageWrapper} from "./component"
import {MissionCard as MissionCardModel} from "../../../../models/secondary-nav"
import {MISSION_BLOCK_DATA_GA, VISITED_PAGES} from "../../../../config/constants"
import {configRelativePathURL} from "../../../../utils/configUrlPath"
import {setDepartment} from "../../../../utils/setDepartment"

export type DefaultTemplatePropType = {
    title: string
    imageUrl: string
}

type MissionCardProps = MissionCardModel & {
    department: string
    target: string | null
    url: string
    rememberSelectedDepartment: boolean
}

const onClick = (target, department, rememberSelectedDepartment) => {
    localStorage.removeItem(VISITED_PAGES)
    setDepartment(target, department, rememberSelectedDepartment)
}

export const MissionCard: React.FC<MissionCardProps> = ({
    imageUrl,
    target,
    title,
    department,
    url,
    rememberSelectedDepartment,
}) => {
    const validTarget = configRelativePathURL(target ?? "", url)

    return (
        <Container
            onClick={() => onClick(validTarget, department, rememberSelectedDepartment)}
            href={validTarget}
            data-testid="header-mission-card"
            data-ga-v1={MISSION_BLOCK_DATA_GA}
            data-ga-v2={department}
            data-ga-v3={title}
        >
            <ImageWrapper>
                <ImageContainer alt={title} src={imageUrl} />
            </ImageWrapper>
            <ImageTitle> {title} </ImageTitle>
        </Container>
    )
}

export default MissionCard
